import { ComponentProps } from "react";
import { cn } from "@repo/utils/cn";

export type SectionProps = {
  isHeroSection?: boolean;
  isGrouped?: boolean;
  paddingTop?: "default" | "large";
  defaultPaddingBottom?: string;
  borderTop?: "borderMuted" | "borderCropped";
  verticalPaddings?: "default" | "large";
  hideSection?: boolean;
  enableTextFade?: boolean;
} & ComponentProps<"section">;

export function Section({
  className,
  paddingTop,
  defaultPaddingBottom,
  borderTop,
  verticalPaddings,
  children,
  hideSection,
  isGrouped,
  ...props
}: SectionProps) {
  const classNames: string[] = [];

  classNames.push("ui:pt-sectionTop");
  classNames.push(defaultPaddingBottom || "ui:pb-sectionBottom");

  if (paddingTop === "large") {
    classNames.push("ui:pt-sectionVertical");
  }

  if (!isGrouped) {
    if (verticalPaddings === "default") {
      classNames.push(defaultPaddingBottom || "ui:pb-sectionTop");
    }
    if (verticalPaddings === "large") {
      classNames.push("ui:pt-sectionVertical");
      classNames.push("ui:pb-sectionVertical");
    }
  }

  if (isGrouped) {
    classNames.push("ui:bg-transparent");
    classNames.push("ui:inverted");
  }

  if (borderTop === "borderMuted") {
    classNames.push("ui:border-t ui:border-borderMuted");
  }

  delete props.isHeroSection;

  delete props.enableTextFade;

  if (hideSection) {
    return null;
  }

  return (
    <section
      {...props}
      className={cn("ui:scroll-mt-header", classNames, className)}
    >
      {borderTop === "borderCropped" && (
        <hr className="ui:m-0 ui:mx-auto ui:h-px ui:w-full ui:max-w-[1440px] ui:border-0 ui:bg-borderMuted" />
      )}
      {children}
    </section>
  );
}
